<div class="list-item-component">
	<div class="flex flex-wrap">
		<div class="list-item-item-icon col-2">
			<div class='list-icon'>
				<mat-icon class="list-item-sider list-item-icon" mat-list-icon>{{
					icon
				}}</mat-icon>
			</div>
		</div>
		<div class="list-item-item-body col-10">
			<div class="list-item-header">
				<span class="list-item-author">{{ title }}</span>
			</div>
			<div class="list-item-message">{{ value }}</div>
		</div>
	</div>
</div>
